import React, { useState } from 'react';
import { useMutation, useQuery } from 'react-query';
import { Alert, Button, Col, Container, FormGroup, Row, Spinner } from 'reactstrap';
import { PhraseService } from '../../../services';
import useDebounce from '../../../utils/useDebounce';

const stripHtml = (html) => {
  const tmp = document.createElement('DIV');
  tmp.innerHTML = html;
  return tmp.textContent || tmp.innerText || '';
};

const synth = window.speechSynthesis;
const speak = (text) => {
  const uttr = new SpeechSynthesisUtterance();
  uttr.text = text;
  uttr.rate = 0.8;
  synth.speak(uttr);
};

const PagePhrases = () => {
  const [keyword, setKeyword] = useState('');

  const debouncedKeyword = useDebounce(keyword.trim(), 500);

  const { data, isLoading, refetch } = useQuery(
    ['getPhrases', debouncedKeyword],
    () => PhraseService.getPhrases({ keyword: debouncedKeyword }),
    { retry: false },
  );

  const items = data || [];

  const { mutate: deletePhrase } = useMutation(PhraseService.deletePhrase, {
    onSuccess: () => refetch(),
  });

  return (
    <section className="section p-0 mt-4 mb-5 pb-5">
      <Container>
        <Row className="mb-3">
          <Col md={7}>
            <FormGroup className="mb-0">
              <input
                type="text"
                className="form-control rounded-pill shadow-sm"
                placeholder="Search your notes..."
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
              />
            </FormGroup>
          </Col>
        </Row>

        {isLoading ? (
          <div className="text-center py-5">
            <Spinner color="primary" />
            <p className="text-muted mt-2">Loading your notes...</p>
          </div>
        ) : items.length === 0 ? (
          <Alert color="info">
            {keyword ? `No notes match "${keyword}".` : "You haven't saved any notes yet. Use the Writing Helper in the extension to save phrases."}
          </Alert>
        ) : (
          <div className="bg-white rounded shadow-sm">
            {items.map((item, i) => (
              <div
                key={item.id}
                className="d-flex align-items-start gap-3 p-3"
                style={{ borderBottom: i < items.length - 1 ? '1px solid #f1f3f5' : 'none' }}
              >
                <button
                  className="btn btn-link p-0 text-muted flex-shrink-0"
                  style={{ fontSize: '1.1rem', marginTop: 2 }}
                  onClick={() => speak(stripHtml(item.phrase))}
                  title="Listen"
                >
                  <i className="uil uil-volume-up" />
                </button>
                <div
                  className="flex-grow-1 text-dark"
                  style={{ fontSize: '0.95rem', lineHeight: 1.6 }}
                  dangerouslySetInnerHTML={{ __html: item.phrase }}
                />
                <Button
                  size="sm"
                  color="outline-danger"
                  className="rounded-pill flex-shrink-0"
                  style={{ fontSize: '0.75rem' }}
                  onClick={() => deletePhrase(item.id)}
                >
                  Delete
                </Button>
              </div>
            ))}
          </div>
        )}
      </Container>
    </section>
  );
};

export default PagePhrases;
